import { useEffect, useState } from "react"

export function useVisibleElementWidth(refs: React.RefObject<HTMLElement | null>[]) {
	const [width, setWidth] = useState(0)

	useEffect(() => {
		const visibleEl = refs.find(
			(ref) =>
				ref.current &&
				ref.current.offsetParent !== null && // display !== 'none'
				getComputedStyle(ref.current).display !== "none",
		)?.current

		if (!visibleEl) return

		const update = () => {
			setWidth(visibleEl.offsetWidth)
		}

		// Set initially
		update()

		// Observe future changes
		const observer = new ResizeObserver(update)
		observer.observe(visibleEl)

		return () => observer.disconnect()
	}, [refs.map((r) => r.current).join("-")]) // ensure re-run when refs change

	return width
}

export function useVisibleElementHeight(refs: React.RefObject<HTMLElement | null>[]) {
	const [height, setHeight] = useState(0)

	useEffect(() => {
		const visibleEl = refs.find(
			(ref) =>
				ref.current &&
				ref.current.offsetParent !== null && // display !== 'none'
				getComputedStyle(ref.current).display !== "none",
		)?.current

		if (!visibleEl) return

		const update = () => {
			setHeight(visibleEl.offsetHeight)
		}

		// Set initially
		update()

		// Observe future changes
		const observer = new ResizeObserver(update)
		observer.observe(visibleEl)

		return () => observer.disconnect()
	}, [refs.map((r) => r.current).join("-")]) // ensure re-run when refs change

	return height
}
